import { Injectable } from '@angular/core';
import { SERVICIOS_URL, SERVICIO_URL, BASE_MAPS, API_KEY, UBICACION_URL,
         GEOCODE, USERS_URL, RAIZ, REGISTRO_URL, NOTIFY_URL } from '../components/Config/globals.config';
import { Http, Headers } from '@angular/http';
import { Servicio } from '../interfaces/servicio.interface';
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import 'rxjs/Rx';

@Injectable()
export class ServicioService {

  constructor( private http:Http, private afDB: AngularFireDatabase ) {

  }

  nuevoServicio( servicio:Servicio ){

    let cuerpo = JSON.stringify(servicio);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    return this.http.post( SERVICIOS_URL, cuerpo, { headers:headers }).map(res=>{
           return res.json();
         });
  }

  actualizaCoord( serv:any, key$:string ){
    let cuerpo = JSON.stringify(serv);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ SERVICIO_URL }/${ key$ }.json`;

    return this.http.put( url, cuerpo, { headers:headers }).map(res=>{
         console.log( "Actualiza", res.json());
         return res.json();
       });
  }

  actualizaServicio(user:any, id:any){

    let cuerpo = { 'status':id };

    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ UBICACION_URL }/${ user }.json`;

    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
        console.log( "Actualiza", res.json()) ;
        return res.json();
    });
  }

  actServicio(user:any ){

    let cuerpo = { 'status': 0 };

    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ UBICACION_URL }/${ user }.json`;

    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
        console.log( "Actualiza", user, res.json()) ;
        return res.json();
    });
  }

  getDirections(inicial:any, final:any){

    let headers = new Headers({
      'Access-Control-Allow-Origin' : '*',
			'Access-Control-Allow-Methods' : 'POST, GET, OPTIONS, PUT',
			'Content-Type': 'application/json',
			'Accept': 'application/json'
    });

    return this.http.get(BASE_MAPS +"/directions/json?origin="+inicial+"&destination="+final+"&key="+API_KEY, { headers:headers })
              .map(res=>res.json());
  }

  getDistancia(inicial:any, final:any){
    let headers = new Headers({
      'Access-Control-Allow-Origin' : '*'
    });

    return this.http.get(BASE_MAPS+"/distancematrix/json?units=imperial&origins="+inicial+"&destinations="+final+"&key="+ API_KEY)
              .map(res=>res.json());
  }

  getServicio( key$:string ){

    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ SERVICIO_URL }/${ key$ }.json`;
    return this.http.get( url, headers ).map(res=>res.json());

  }

  geocode(coord:any){
    return this.http.get( GEOCODE + coord + "&key=" + API_KEY).map(res=>res.json());
  }

  getUsers( user:any ){

    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ USERS_URL }/${ user }.json`;
    return this.http.get( url, headers ).map(res=>res.json());

  }

  getUsersUnidad( user:any ){

    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ USERS_URL }/${ user }/unidad.json`;
    return this.http.get( url, headers ).map(res=>res.json());

  }

  act_datos_user( datos:any, key$:string ){
    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ USERS_URL }/${ key$ }.json`;

    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
         console.log( "Actualiza", res.json());
         return res.json();
       });
  }

  act_user( datos:any ){
    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ RAIZ }/users.json`;

    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
         console.log( "Actualiza", res.json());
         return res.json();
       });
  }

  nuevoUser( datos:any, nodo:any ){

    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
			'Content-Type': 'application/json',
    });

    let url = `${ USERS_URL }/` + nodo + `.json`;
    console.log(url+cuerpo);
    return this.http.put( url, cuerpo, { headers:headers }).map(res=>{
           console.log(res.json());
           return res.json();
         });
  }
  /*
  newUser(datos:any){
    let cuerpo = JSON.stringify(datos);
    let url = `${ USERS_URL }ejemplo.json`;
    return this.http.put(url, cuerpo).map(res=>{
      console.log(res.json());
      return res.json();
    });
  }
  */
  nuevoUbicacion( datos:any, nodo:any ){

    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ UBICACION_URL }/`+ nodo +`.json`;

    return this.http.put( url , cuerpo, { headers:headers }).map(res=>{
           console.log(res.json());
           return res.json();
         });
  }

  borrarUser( user:any ){
    let url = `${ USERS_URL }${ user }.json`;
    return this.http.delete( url ).map(res=>res.json());
  }

  borrarNotificaciones(){
    let url = `${ NOTIFY_URL }.json`;
    return this.http.delete( url ).map(res=>res.json());
  }

  borrarHistorial(user:any){
    let url = `${ REGISTRO_URL + user }.json`;
    return this.http.delete( url ).map(res=>res.json());
  }

  borrarUbic( user:any ){
    let url = `${ UBICACION_URL }${ user }.json`;
    return this.http.delete( url ).map(res=>res.json());
  }

  borrarReg( user:any ){
    let url = `${ REGISTRO_URL }${ user }.json`;
    return this.http.delete( url ).map(res=>res.json());
  }

  act_unidad( datos:any, user:any ){
    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });

    let url = `${ USERS_URL }${ user }/unidad.json`;

    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
       return res.json();
     });
  }

  act_datos_serv(datos:any, key:string){
    let cuerpo = JSON.stringify(datos);
    let headers = new Headers({
      'Content-Type':'aplication/json'
    });
    let url = `${ SERVICIO_URL }${ key }.json`;
    return this.http.patch( url, cuerpo, { headers:headers }).map(res=>{
      return res.json();
    });
  }

  directions(inicial:any, final:any){
    let headers = new Headers({
      'Access-Control-Allow-Origin' : '*'
    });
    return this.http.get(BASE_MAPS+"/directions/json?origin="+inicial+"&destination="+final+"&key"+API_KEY,{ headers:headers })
              .map(res=>res.json());
  }

  snapToRoad(coords:any){
    let headers = new Headers({
      'Access-Control-Allow-Origin':'*'
    });


    let url ="https://roads.googleapis.com/v1/snapToRoads?path="+ coords +"&interpolate=true&key="+API_KEY;
    return this.http.get(url, { headers:headers }).map(res=>res.json());
   }
   consult_users(){
     let headers = new Headers({
       'Content-Type':'aplication/json'
     });

     let url = `${ UBICACION_URL }.json`;
     return this.http.get( url, headers ).map(res=>res.json());
   }

   consult_user(user:any){
     let headers = new Headers({
       'Content-Type':'aplication/json'
     });

     let url = `${ UBICACION_URL + user }.json`;
     return this.http.get( url, headers ).map(res=>res.json());

   }
   /*  Consulta Espesifica del historial*/
   historial(user:any,valor1:number, valor2:number){
     const hist = this.afDB.list('/registro/'+user, {
       query:{
         orderByChild:'timestamp',
         startAt:valor1,
         endAt:valor2
       }
     });
     //ref => ref.orderByChild('timestamp').startAt(valor1).endAt(valor2)
     //const hist = this.afDB.database.ref('/registro/pizanho18').orderByChild('timestamp').startAt(valor1).endAt(valor2);

     return hist;
   }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/servicios/servicios.service.ts